"use client";

import * as React from "react";
import { MessageCircle, Phone } from "lucide-react";

const PHONE_NUMBER = "9597255401";
const WHATSAPP_NUMBER = "919597255401";

export default function FloatingContactActions() {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const timer = window.setTimeout(() => setIsVisible(true), 900);

    return () => window.clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-5 right-4 z-40 flex flex-col gap-3 sm:bottom-6 sm:right-6">

      {/* CALL BUTTON */}
      <a
        href={`tel:${PHONE_NUMBER}`}
        aria-label="Call Karuppasamy Temple"
        className="group flex h-14 w-14 items-center justify-center rounded-full border border-[#F5D08A]/30 bg-gradient-to-br from-[#6A1B1A] via-[#8B2E1D] to-[#C48A3A] text-white shadow-[0_18px_40px_rgba(90,32,12,0.35)] transition-all duration-300 hover:-translate-y-1 hover:scale-105"
      >
        <Phone className="h-5 w-5 transition-transform duration-300 group-hover:scale-110" />
      </a>

      {/* WHATSAPP BUTTON */}
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp Karuppasamy Temple"
        className="group flex h-14 w-14 items-center justify-center rounded-full border border-white/20 bg-[#25D366] text-white shadow-[0_18px_40px_rgba(37,211,102,0.24)] transition-all duration-300 hover:-translate-y-1 hover:scale-105"
      >
        <MessageCircle className="h-5 w-5 transition-transform duration-300 group-hover:scale-110" />
      </a>
    </div>
  );
}